import StarsCommon from './containers/starsCommon'

export {default as StarsCommonLayout} from './components/starsCommonLayout'

export default StarsCommon
